import React from 'react';
import { Button, Col, Row } from "antd"

export const MpaFormsFooter = (props) => {
    return(
        <Row className='w-100'>
            <Col span="14"></Col>
            <Col span="4"><Button type="link" block htmlType="submit" disabled={props.disableFields}>Save</Button></Col>
            <Col span="2"></Col>
            <Col span="4"><Button type="primary" disabled={props.approveDisabled || props.disableFields} block onClick={() => props.onApprove()}>Approve</Button></Col>
        </Row>
    )
}